<template>
  <div class="search-info-container">
    <custom-router-link :item="info" class="search-link" :to="{name: 'Details', params: {id: info.id}}" target="_blank">
      <div class="content-title">{{info.name}}</div>
      <div class="content-info">
        <span>浏览量：{{info.hit}}</span>
        <span>发布时间：{{info.publishTime && info.publishTime.split(" ")[0]}}</span>
      </div>
    </custom-router-link>
  </div>
</template>

<script>
export default {
  data() {
    return {

    }
  },
  props: {
    info: {
      type: Object,
      default: () => { }
    }
  },
  components: {

  },
  mounted() {

  },
  methods: {

  },
}
</script>

<style lang="less" scoped>
.search-info-container {
  width: 100%;
  background: #ffffff;
  border: 1px solid #dfdfdf;
  box-shadow: 0px 0px 4px 2px rgba(0, 0, 0, 0.08);
  padding: 14px;
  margin-bottom: 20px;
  .search-link {
    display: block;
    width: 100%;
    height: 100%;
    cursor: pointer;
  }
  .content-title {
    width: 100%;
    margin-bottom: 8px;
    font-size: 18px;
    font-weight: 600;
    color: #212529;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .content-info {
    font-size: 14px;
    line-height: 22px;
    color: #6c757d;
    span {
      margin-right: 20px;
    }
  }
}

@media screen and (max-width: 768px) {
  .search-info-container {
    box-shadow: 0px 0px 4px 2px rgba(0, 0, 0, 0.04);
    margin-bottom: 14px;
    .content-title {
      width: 100%;
      margin-bottom: 8px;
      font-size: 14px;
    }
    .content-info {
      font-size: 12px;
      line-height: 20px;
      span {
        margin-right: 20px;
      }
    }
  }
}
</style>